import { render, staticRenderFns } from "./HiddenTab.vue?vue&type=template&id=19a7ced4"
import script from "./HiddenTab.vue?vue&type=script&lang=js"
export * from "./HiddenTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports